import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, Input } from '../components/ui/Forms';
import SafeIcon from '../common/SafeIcon';

export default function Login() {
  const { login, signup } = useAuth();
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const { error } = isLogin ? await login(email, password) : await signup(email, password);
      if (error) setError(error.message);
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="max-w-md w-full bg-white p-10 rounded-[40px] shadow-xl border border-slate-100">
        <div className="text-center mb-10">
          <div className="w-28 h-28 mx-auto mb-6 bg-teal-50 rounded-[32px] flex items-center justify-center shadow-inner">
            <img 
              src="https://media-manager-c.questera.ai/greta-media/981ecb6892631c31e92fca6d10d0332603596e5d429fd99cee63046a83be378b4365dffb7696bc6c52f453f1ea7f8977/images/aW1hZ2UvcG5n/10223f85c5cee27bf98990ec846a54be.png" 
              alt="SubSift Toucan Logo" 
              className="w-20 h-20 object-contain drop-shadow-sm" 
            />
          </div>
          <h1 className="text-3xl font-extrabold text-slate-900 tracking-tight">
            {isLogin ? 'Welcome Back' : 'Create Account'}
          </h1>
          <p className="text-slate-500 mt-2 font-medium">Your subscription intelligence hub.</p>
        </div>

        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-100 text-red-600 rounded-2xl text-sm flex items-center gap-3">
            <SafeIcon name="AlertCircle" className="w-5 h-5 flex-shrink-0" />
            <span className="font-medium">{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-5">
          <Input 
            label="Email Address" 
            type="email" 
            required 
            value={email} 
            onChange={e => setEmail(e.target.value)} 
            placeholder="you@example.com"
            className="rounded-xl"
          />
          <Input 
            label="Password" 
            type="password" 
            required 
            value={password} 
            onChange={e => setPassword(e.target.value)} 
            placeholder="••••••••"
            className="rounded-xl"
          />
          <Button type="submit" className="w-full py-4 rounded-2xl text-base shadow-lg shadow-teal-500/20" disabled={loading}>
            {loading ? 'Processing...' : isLogin ? 'Sign In' : 'Get Started'}
          </Button>
        </form>

        <div className="mt-8 text-center">
          <button 
            onClick={() => setIsLogin(!isLogin)} 
            className="text-sm font-bold text-teal-600 hover:text-teal-700 transition-colors"
          >
            {isLogin ? "New to SubSift? Create an account" : "Already have an account? Sign in"}
          </button>
        </div>
      </div>
    </div>
  );
}